const cueSet1 = [
    {
        "duration": 7.128708,
        "durationTicks": 184320,
        "midi": 55,
        "name": "G3",
        "ticks": 0,
        "time": 0,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 7.128708,
        "durationTicks": 184320,
        "midi": 58,
        "name": "A#3",
        "ticks": 184320,
        "time": 7.128708,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 7.128708,
        "durationTicks": 184320,
        "midi": 55,
        "name": "G3",
        "ticks": 368640,
        "time": 14.257416,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 7.128708,
        "durationTicks": 184320,
        "midi": 58,
        "name": "A#3",
        "ticks": 552960,
        "time": 21.386124,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 7.128708000000003,
        "durationTicks": 184320,
        "midi": 55,
        "name": "G3",
        "ticks": 737280,
        "time": 28.514832,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 7.128707999999996,
        "durationTicks": 184320,
        "midi": 58,
        "name": "A#3",
        "ticks": 921600,
        "time": 35.64354,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 7.128708000000003,
        "durationTicks": 184320,
        "midi": 55,
        "name": "G3",
        "ticks": 1105920,
        "time": 42.772248,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 7.128707999999996,
        "durationTicks": 184320,
        "midi": 58,
        "name": "A#3",
        "ticks": 1290240,
        "time": 49.900956,
        "velocity": 0.7874015748031497
    }
];

export default cueSet1;